module.exports = __webpack_public_path__ + "static/ai_meme-57aac1d6c0dcfac5f2e6555fc101e07a.jpg";